// extracted by mini-css-extract-plugin
export default {"circleStyle":"MenuSelector_circleStyle__rCQn+","font":"MenuSelector_font__XDqyV"};